import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { fetchStripeCustomerDetails } from "../../js/helpers/stripeAPI";
import { fetchCustomerDetails } from "../../features/employer/employerActions";

export default function useCustomerDetails({
  shouldExecute = false,
  account,
  deps = [],
}) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!shouldExecute) return;
    fetchStripeCustomerDetails({
      email: account.email,
      subscriptionId: account?.subscriptionId || null,
      stripeCustomerId: account?.stripeCustomerId || null,
    })
      .then((details) => {
        dispatch(fetchCustomerDetails(details));
      })
      // .then((res) => console.log(res))
      .catch((e) => console.log(e));
  }, deps); // eslint-disable-line react-hooks/exhaustive-deps
}
